export { customerActionCreator } from './parts/customer-action';
export { customerReducer } from './parts/customer-reducer';
export * from './parts/customer-selector';
export { ICustomer, ICustomerStore } from './parts/customer-type';



// WEBPACK FOOTER //
// ./src/modules/customers/index.ts